import { render, staticRenderFns } from "./roles-settings.vue?vue&type=template&id=0436267f&"
import script from "./roles-settings.ts?vue&type=script&lang=js&"
export * from "./roles-settings.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports